import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { getUnavailabilityBatch } from '../../services/availability';

function useGetUnavailabilityBatch({
  employeeIds,
  startDate,
  endDate,
}: {
  employeeIds: string[];
  startDate: string;
  endDate: string;
}) {
  const { user } = useUser();

  const sortedIds = useMemo(() => [...employeeIds].sort(), [employeeIds]);

  return useQuery({
    queryKey: [
      'unavailability-batch',
      user?.userId,
      user?.business?.id,
      startDate,
      endDate,
      sortedIds,
    ],
    queryFn: async ({ signal }) => {
      const result = await getUnavailabilityBatch({
        startDate,
        endDate,
        employeeIds: sortedIds,
        signal,
      });
      return result;
    },
    enabled: !!user?.userId && !!user?.business?.id,
  });
}

export default useGetUnavailabilityBatch;
